import { css } from "lit";

export const styles = css`
    :host {
        display: block;
    }

    .container {
        flex-direction: row;
        justify-content: space-between;
        padding: 1em;
        align-items: center;
    }

    .banner {
        width: 100%;
        isolation: isolate;
    }

    .header {
        width: 100%;
        position: absolute;
        top: 0em;
        left: 0em;
    }

    .header.menu {
        background-color: white;
        color: black;
    }

    .content-container {
        position: absolute;
        top: 0em;
        left: 0em;
        width: 100%;
        height: 100%;
    }

    .content {
        justify-content: center;
        align-items: center;
        height: 100%;
    }

    .content .cta {
        font-size: 3em;
    }

    .content bb-search-bar {
        width: 500px;
    }

    .content h1 {
        color: white;
    }

    .content a {
        text-decoration: underline;
    }

    .logo {
        width: 15em;
    }

    .icon {
        width: 5em;
    }

    .menu-icon {
        color: white;
        font-size: 2em;
    }

    .menu-items {
        gap: 1em;
        justify-content: flex-end;
    }

    .menu-items a {
        display: inline-flex;
        gap: 0.5em;
        align-items: center;
    }

    .menu-items sl-button {
        align-content: center;
    }

    .background-image {
        object-fit: cover;
        width: 100%;
        filter: brightness(60%);
    }

    a {
        color: white;
        text-decoration: none;
        cursor: pointer;
    }

    .menu a {
        color: black;
    }

    ds-search-bar {
        width: 90%;
    }

    @media only screen and (min-width: 640px) {
        ds-search-bar {
            width: 90%;
        }
    }

    @media only screen and (min-width: 768px) {
        ds-search-bar {
            width: 80%;
        }
    }

    @media only screen and (min-width: 1024px) {
        ds-search-bar {
            width: 50%;
        }
    }

    @media only screen and (min-width: 1280px) {
        ds-search-bar {
            width: 50%;
        }
    }
`;
